import {
  Filter,
  serializeFilter,
} from "./pages/specialty-assistant/dashboard/filter";

export const ROUTES = {
  // Logged out
  LANDING: "/",

  // Logged in
  BROKER_ANALYTICS: "/broker-analytics",
  DASHBOARD: "/dashboard",
  DASHBOARD_WITH_FILTER: (filter: Filter) =>
    `/dashboard/reports?${serializeFilter(filter)}`,
  DASHBOARD_CASUALTY: "/dashboard/reports/casualty",
  DASHBOARD_ANALYTICS: "/dashboard/analytics",
  DASHBOARD_EXPOSURE_MAP: "/dashboard/exposure-map",
  DASHBOARD_POLICYFLY: "/dashboard/policyfly",
  DASHBOARD_REPORT: (
    reportId: string | number,
    tabPath?: string,
    search?: string
  ) =>
    `/dashboard/report/${reportId}${tabPath ? "/" + tabPath : ""}${
      search ?? ""
    }`,
  DASHBOARD_POLICY_APPLICATION: (applicationId: string) =>
    `/dashboard/policy/${applicationId}`,
  DASHBOARD_SUBMISSION_HISTORY: "/dashboard/submission-history",
  DASHBOARD_SUBMISSION_HISTORY_DETAIL: (reportId: string | number) =>
    `/dashboard/submission-history/detail/${reportId}`,
};
